// Back-compat shim. The real tokens now live in the shared @b/ui package;
// this file only re-exports them plus the app-specific tint aliases that
// existing pages import from "./design/tokens". New code should import from
// "@b/ui" and read the tint via useBrand() where possible.
export * from "@b/ui";

import { brand } from "../brand";

export const ReceiptHandlingTint = brand.tint;
export const ReceiptHandlingAccent = brand.tint.ink;
